import React from "react";
import { ArtWork } from "../types/ArtWork";
import { digitalArtworkById } from "../data/digitalArtworks";
import { ArtworkLightboxShell } from "./ArtworkLightboxShell";
import { DigitalLightboxContent } from "./DigitalArtworkCards";

export function DigitalLightbox({
  work,
  onClose,
  onNavigate,
  showNavigation = true,
  exploreGalleryHref,
}: {
  work: ArtWork;
  onClose: () => void;
  onNavigate?: (direction: -1 | 1) => void;
  showNavigation?: boolean;
  exploreGalleryHref?: string;
}) {
  const resolved = digitalArtworkById(work.id) ?? work;
  return (
    <ArtworkLightboxShell
      ariaLabel={work.id}
      imageUrl={resolved.imageUrl}
      imageAlt={work.name}
      onClose={onClose}
      onNavigate={onNavigate}
      showNavigation={showNavigation}
    >
      <DigitalLightboxContent work={work} exploreGalleryHref={exploreGalleryHref} />
    </ArtworkLightboxShell>
  );
}
